import { render, staticRenderFns } from "./JobGroupHistories.vue?vue&type=template&id=21c5b185&"
import script from "./JobGroupHistories.vue?vue&type=script&lang=js&"
export * from "./JobGroupHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports